export const trackSte = (
	action: string,
	data: Record<string, unknown> = {},
) => {
	try {
		window.ste_statistic = window.ste_statistic || [];
		window.ste_statistic.push({
			action,
			data,
		});

		console.info(`STE TRACKING: ${action}`, JSON.stringify(data, null, 2));
	} catch (_error) {
		console.warn(
			`STE TRACKING ERROR: ${action}`,
			JSON.stringify(data, null, 2),
		);
	}
};
